import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
var PrivateRoute = function (_a) {
    var children = _a.children;
    var isAuthenticated = useAppContext().isAuthenticated;
    return isAuthenticated ? children : _jsx(Navigate, { to: '/auth' });
};
export default PrivateRoute;
